import styled from "@emotion/styled";
import { Select, MenuItem, Paper } from "@mui/material";

type Props = {
  ifSecondFontColor?: string;
};

export const SettingPaper = styled(Paper)`
  max-width: 270px;
  height: auto;
  margin-right: 1px;
  padding: 1px 1px 3px 3px;
  border: 0.5px solid #333;
`;

export const Selector = styled(Select)<Props>`
  .MuiSelect-root.MuiSelect-select.MuiSelect-selectMenu {
    ${({ ifSecondFontColor }) =>
      ifSecondFontColor ? `color: ${ifSecondFontColor};` : `color: #444;`}
  }
  .MuiInputBase-root.MuiInput-root.MuiInput-underline&:before {
    border-bottom: none;
  }
  .MuiInputBase-root.MuiInput-root.MuiInput-underline&:after {
    border-bottom: none;
  }
`;

export const SelectorOption = styled(MenuItem)`
  font-size: 10px;
  margin: 0px;
`;

export const SettingUnit = styled.div`
  display: flex;
  flex-direction: row;
  justity-content: flex-end;
  align-items: center;
  padding: 8px 8px 3px 8px;
`;

export const SettingUnitTitle = styled.span`
  font-size: 12px;
  margin-right: 5px;
`;

export const SettingAction = styled.div`
  margin-left: auto;
`;
